// ----------------------------------------------------------------------------
// Snippet: Variant Picker
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_variant-picker.scss';

// Variables
const SELECTOR_WRAPPER_CLASS = '.selector-wrapper';

// Functions
class VariantPicker extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        this.productSelect = document.querySelector('[data-product-select]');
        this.lowInventoryMessageEnabled = this.productSelect.dataset.lowInventoryMessageEnabled;
        this.lowInventoryThreshold = parseInt(this.productSelect.dataset.lowInventoryThreshold);
        this.lowInventoryContainer = document.querySelector('.low-inventory__container');
    }
    
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();

        if (typeof this.lowInventoryMessageEnabled !== "undefined" && this.lowInventoryMessageEnabled == "true" && typeof this.lowInventoryThreshold !== "undefined") {
            const currentVariantQuantity = parseInt(this.productSelect.selectedOptions[0].dataset.inventoryQuantity);
            
            if (currentVariantQuantity <= this.lowInventoryThreshold && currentVariantQuantity > 0) {
                this.lowInventoryContainer.style.display = "block";
            } else {
                this.lowInventoryContainer.style.display = "none";
            }
        }
    }

    // Update the selected options. Example of what the options array looks like: ["Blue", "Small"]
    updateOptions() {
        const selectorWrappers = Array.from(this.querySelectorAll(SELECTOR_WRAPPER_CLASS));
        this.options = selectorWrappers.map((selectorWrapper) => {
            if (selectorWrapper.classList.contains('form__field--swatches')) {
                return Array.from(selectorWrapper.querySelectorAll('input')).find((radio) => radio.checked).value;
            } else {
                return selectorWrapper.querySelector('select').value;
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });

        if(this.currentVariant !== undefined) {
            document.querySelector('[data-product-form]').dataset.currentVariantId = this.currentVariant.id; // Update the attribute
        }
    }

    updateVariantStatuses() {
        // Get all the possible variants based on the selected option one (including unavailable/sold out variants). 
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => this.querySelector(':checked').value === variant.option1
        );
        const selectorWrappers = this.querySelectorAll(SELECTOR_WRAPPER_CLASS);

        // Looping through each option selector (exclude the option1 selector since we only need to update the availability status on option 2 and 3 when applicable)
        selectorWrappers.forEach((option, index) => {   
            if (index === 0) return;

            // Getting all the inputs of the current selector
            const optionInputs = option.querySelectorAll('input[type="radio"], option');

            // Get the selected option value of the previous selector.
            const previousOptionSelected = selectorWrappers[index - 1].querySelector(':checked').value;

            // Get all the available options of the current selector
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            const swatchOption = input.closest('.swatch__option');
            if (swatchOption) {
                // If it's a swatch option, toggling disabled class based on variant availability
                if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                    swatchOption.querySelector('.form__option-label').classList.remove('swatch--disabled');
                } else {
                    swatchOption.querySelector('.form__option-label').classList.add('swatch--disabled');
                }
            }
        });
    }
}

customElements.define('iam-variant-picker', VariantPicker);